import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { ICountry } from '../interfaces/country.interface';
import { CurrencyRateModel } from './currency-rate.model';
export class CountryModel extends BaseModel implements ICountry {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  isDefault?: boolean;

  @Expose()
  defaultCurrencyId?: number;

  @Expose()
  defaultCurrency?: CurrencyRateModel;
}
